import React from 'react';
import PropTypes from 'prop-types';
import { Grid, FormControlLabel, Checkbox, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Brightness1 } from '@material-ui/icons';

export default function LegendUnit({ name, index, color, number, checked, onClick, handleDisplay, ExpandIcon, isTitle, level}) {
    const showColor = color && (number || ExpandIcon) && (isTitle === false); // lvl 1 programs do not have a representative color.
    const classes = makeStyles(theme => ({
        colorIcon: {
            color: showColor ? color : 'transparent',
            width:'16px',
            height:'16px',
            marginRight:'7px'
        },
        name: {
            fontSize:'13.5px',
            letterSpacing:'0px',
            color:"#384257",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            fontWeight: level === 1 ? "bold" : "normal"
        },
        expandIcon: {
            cursor: 'pointer',
            color:'#384257',
            marginRight: '-15px',
            marginLeft: '25px',
            width: '30px',
            opacity: 1.5-(level*0.5)
        },
        number: {
            fontSize: '13.5px',
            color: '#384257',
            marginBottom: '4.5px',
            marginRight: 'auto',
            paddingRight: ExpandIcon? '0px': '40px',
            width: '0px'
        },
        formLabel: {
            width: '100%',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            paddingLeft: level === 1? '0px': level === 2? '13px' : level*10,
            '& span': {
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
            }
        },
        rightGrid: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
        }
    }))();

    return <Grid item container display='flex' direction='row' alignItems='center'>
                <Grid xs item className={classes.rightGrid}>
                    <FormControlLabel
                        className={classes.formLabel}
                        control={
                            <Checkbox
                                id={`eye_${index}`}
                                checked={checked}
                                onChange={onClick}
                                style={{color: '#384257'}}
                            />
                        }
                        label={<Typography className={classes.name}>{name}</Typography> }
                    />
                    <Grid item >
                        <Brightness1 className={classes.colorIcon}/>
                    </Grid>
                    <Grid item className={classes.rightGrid}>
                        {number !== undefined && !isNaN(number) && <Grid item xs={1}className={classes.number}>{`\u00a0${number}`}</Grid> }
                        { ExpandIcon !== null && ExpandIcon &&
                            <Grid item>
                            <ExpandIcon className={classes.expandIcon} onClick={handleDisplay}/>
                            </Grid>
                        }
                    </Grid>
                </Grid>
    </Grid> ;
}

LegendUnit.propTypes = {
    /**
     * Name of the element represented in this unit
     */
    name: PropTypes.string.isRequired,
    /**
     * Color of the element represented in a visualization
     */
   // color: PropTypes.string.isRequired,
    /**
     * Number of ocurrences the element represented is in a visualization
     */
    number: PropTypes.number,
    /** Color for number and name */
    labelColor: PropTypes.string
}